var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("span", [_vm._v("Vendor Information")]),
      ]),
      _c(
        "div",
        { attrs: { id: "vendor-source" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.newVendor,
                callback: function ($$v) {
                  _vm.newVendor = $$v
                },
                expression: "newVendor",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: 0, value: 0 } }, [
                _vm._v("Selected"),
              ]),
              _c("el-radio-button", { attrs: { label: -1, value: -1 } }, [
                _vm._v("Assign vendor"),
              ]),
              _c("el-radio-button", { attrs: { label: 1, value: 1 } }, [
                _vm._v("Create new vendor"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.newVendor === -1
        ? _c(
            "div",
            { staticClass: "ca-form", attrs: { id: "vendor-select" } },
            [
              _c("VendorSelect", {
                attrs: {
                  disableCTA: _vm.disableAssignVendorCTA,
                  orderId: _vm.value.orderId,
                  latitude: _vm.value.latitude,
                  longitude: _vm.value.longitude,
                },
                on: {
                  updateNewVendor: _vm.updateNewVendor,
                  assignVendor: _vm.updateVendor,
                },
                model: {
                  value: _vm.value.vendorId,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "vendorId", $$v)
                  },
                  expression: "value.vendorId",
                },
              }),
            ],
            1
          )
        : _vm.newVendor === 1
        ? _c("div", { staticClass: "ca-form" }, [
            _c("div", { attrs: { id: "source-selection" } }, [
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dataSourceType,
                      expression: "dataSourceType",
                    },
                  ],
                  attrs: {
                    id: "dataSource0",
                    type: "radio",
                    name: "dataSource",
                  },
                  domProps: {
                    value: 0,
                    checked: _vm._q(_vm.dataSourceType, 0),
                  },
                  on: {
                    change: function ($event) {
                      _vm.dataSourceType = 0
                    },
                  },
                }),
                _c("label", { attrs: { for: "dataSource0" } }, [
                  _vm._v("Same as Order Information"),
                ]),
              ]),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dataSourceType,
                      expression: "dataSourceType",
                    },
                  ],
                  attrs: {
                    id: "dataSource1",
                    type: "radio",
                    name: "dataSource",
                  },
                  domProps: {
                    value: 1,
                    checked: _vm._q(_vm.dataSourceType, 1),
                  },
                  on: {
                    change: function ($event) {
                      _vm.dataSourceType = 1
                    },
                  },
                }),
                _c("label", { attrs: { for: "dataSource1" } }, [
                  _vm._v("Same as Contact Information "),
                ]),
              ]),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dataSourceType,
                      expression: "dataSourceType",
                    },
                  ],
                  attrs: {
                    id: "dataSource2",
                    type: "radio",
                    name: "dataSource",
                  },
                  domProps: {
                    value: 2,
                    checked: _vm._q(_vm.dataSourceType, 2),
                  },
                  on: {
                    change: function ($event) {
                      _vm.dataSourceType = 2
                    },
                  },
                }),
                _c("label", { attrs: { for: "dataSource2" } }, [
                  _vm._v("New Custom Vendor"),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "w50",
                    attrs: { required: "", label: "Name" },
                  },
                  [
                    this.dataSourceType === 0
                      ? _c("el-input", {
                          attrs: {
                            disabled: this.dataSourceType !== 2,
                            type: "text",
                          },
                          model: {
                            value: _vm.value.borrowerName,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "borrowerName", $$v)
                            },
                            expression: "value.borrowerName",
                          },
                        })
                      : this.dataSourceType === 1
                      ? _c("el-input", {
                          attrs: {
                            disabled: this.dataSourceType !== 2,
                            type: "text",
                          },
                          model: {
                            value: _vm.value.contactFirstName,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "contactFirstName", $$v)
                            },
                            expression: "value.contactFirstName",
                          },
                        })
                      : _c("el-input", {
                          attrs: { type: "text" },
                          model: {
                            value: _vm.vendor.firstName,
                            callback: function ($$v) {
                              _vm.$set(_vm.vendor, "firstName", $$v)
                            },
                            expression: "vendor.firstName",
                          },
                        }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "w50",
                    attrs: { required: "", label: "Last Name" },
                  },
                  [
                    this.dataSourceType === 1
                      ? _c("el-input", {
                          attrs: {
                            disabled: this.dataSourceType !== 2,
                            type: "text",
                          },
                          model: {
                            value: _vm.value.contactLastName,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "contactLastName", $$v)
                            },
                            expression: "value.contactLastName",
                          },
                        })
                      : _c("el-input", {
                          attrs: { type: "text" },
                          model: {
                            value: _vm.vendor.lastName,
                            callback: function ($$v) {
                              _vm.$set(_vm.vendor, "lastName", $$v)
                            },
                            expression: "vendor.lastName",
                          },
                        }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "w50",
                    attrs: { required: "", label: "Phone" },
                  },
                  [
                    this.dataSourceType === 1
                      ? _c("el-input", {
                          attrs: {
                            disabled: this.dataSourceType !== 2,
                            type: "text",
                          },
                          model: {
                            value: _vm.value.contactPhone,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "contactPhone", $$v)
                            },
                            expression: "value.contactPhone",
                          },
                        })
                      : _c("el-input", {
                          attrs: { type: "text" },
                          model: {
                            value: _vm.vendor.phone,
                            callback: function ($$v) {
                              _vm.$set(_vm.vendor, "phone", $$v)
                            },
                            expression: "vendor.phone",
                          },
                        }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticClass: "w50", attrs: { label: "Phone 2" } },
                  [
                    this.dataSourceType === 1
                      ? _c("el-input", {
                          attrs: {
                            disabled: this.dataSourceType !== 2,
                            type: "text",
                          },
                          model: {
                            value: _vm.value.contactPhone2,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "contactPhone2", $$v)
                            },
                            expression: "value.contactPhone2",
                          },
                        })
                      : _c("el-input", {
                          attrs: { type: "email" },
                          model: {
                            value: _vm.vendor.phone2,
                            callback: function ($$v) {
                              _vm.$set(_vm.vendor, "phone2", $$v)
                            },
                            expression: "vendor.phone2",
                          },
                        }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "w50",
                    attrs: { required: "", label: "Email" },
                  },
                  [
                    this.dataSourceType === 1
                      ? _c("el-input", {
                          attrs: {
                            disabled: this.dataSourceType !== 2,
                            type: "text",
                          },
                          model: {
                            value: _vm.value.contactEmail,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "contactEmail", $$v)
                            },
                            expression: "value.contactEmail",
                          },
                        })
                      : _c("el-input", {
                          attrs: { type: "email" },
                          model: {
                            value: _vm.vendor.email,
                            callback: function ($$v) {
                              _vm.$set(_vm.vendor, "email", $$v)
                            },
                            expression: "vendor.email",
                          },
                        }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { attrs: { required: "", label: "Address" } },
                  [
                    this.dataSourceType === 0
                      ? _c("el-input", {
                          attrs: { disabled: true, type: "text" },
                          model: {
                            value: _vm.value.subjectAddress,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "subjectAddress", $$v)
                            },
                            expression: "value.subjectAddress",
                          },
                        })
                      : _c("el-input", {
                          attrs: { type: "text" },
                          model: {
                            value: _vm.vendor.address,
                            callback: function ($$v) {
                              _vm.$set(_vm.vendor, "address", $$v)
                            },
                            expression: "vendor.address",
                          },
                        }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { required: "", label: "City" } },
                  [
                    this.dataSourceType === 0
                      ? _c("el-input", {
                          attrs: { disabled: true, type: "text" },
                          model: {
                            value: _vm.value.subjectCity,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "subjectCity", $$v)
                            },
                            expression: "value.subjectCity",
                          },
                        })
                      : _c("el-input", {
                          attrs: { type: "text" },
                          model: {
                            value: _vm.vendor.city,
                            callback: function ($$v) {
                              _vm.$set(_vm.vendor, "city", $$v)
                            },
                            expression: "vendor.city",
                          },
                        }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      required: "",
                      inlineMessage: true,
                      label: "State",
                    },
                  },
                  [
                    this.dataSourceType === 0
                      ? _c("el-input", {
                          attrs: { disabled: true, type: "text" },
                          model: {
                            value: _vm.value.subjectState,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "subjectState", $$v)
                            },
                            expression: "value.subjectState",
                          },
                        })
                      : _c(
                          "el-select",
                          {
                            attrs: { placeholder: "State", "value-key": "key" },
                            model: {
                              value: _vm.vendor.state,
                              callback: function ($$v) {
                                _vm.$set(_vm.vendor, "state", $$v)
                              },
                              expression: "vendor.state",
                            },
                          },
                          _vm._l(Object.entries(_vm.states), function (ref) {
                            var value = ref[0]
                            var label = ref[1]
                            return _c(
                              "el-option",
                              {
                                key: value,
                                attrs: { label: label, value: value },
                              },
                              [_vm._v(" " + _vm._s(label) + " ")]
                            )
                          }),
                          1
                        ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { required: "", label: "Postal Code" } },
                  [
                    this.dataSourceType === 0
                      ? _c("el-input", {
                          attrs: { disabled: true, type: "text" },
                          model: {
                            value: _vm.value.subjectPostalCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "subjectPostalCode", $$v)
                            },
                            expression: "value.subjectPostalCode",
                          },
                        })
                      : _c("el-input", {
                          attrs: { maxlength: "5", type: "text" },
                          model: {
                            value: _vm.vendor.postalCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.vendor, "postalCode", $$v)
                            },
                            expression: "vendor.postalCode",
                          },
                        }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { attrs: { id: "cta-container" } },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "success" },
                    on: {
                      click: function () {
                        return (_vm.dialogConfirmVendorFee = true)
                      },
                    },
                  },
                  [_vm._v(" Create and Assign New Vendor ")]
                ),
              ],
              1
            ),
          ])
        : _vm.value.vendor !== null
        ? _c("VendorData", {
            attrs: {
              vendor: _vm.value.vendor,
              order: _vm.value,
              hideFee: true,
            },
          })
        : _c("p", [_vm._v("No vendor selected")]),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-confirm-vendor-fee",
          attrs: {
            "close-on-click-modal": false,
            title: "Confirm and Assign New Vendor - " + _vm.value.orderId,
            visible: _vm.dialogConfirmVendorFee,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogConfirmVendorFee = $event
            },
            close: _vm.closeModal,
          },
        },
        [
          _c("VendorData", {
            attrs: { vendor: _vm.vendor, order: _vm.value, hideFee: false },
          }),
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.lodingCreateAndAssign,
                    type: "success",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.createAndAssignVendor()
                    },
                  },
                },
                [_vm._v(" Create and Assign ")]
              ),
              _c(
                "el-button",
                { attrs: { type: "warning" }, on: { click: _vm.closeModal } },
                [_vm._v(" Cancel ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }